import environment from "Configs/environment";
import { useApp } from "Providers/AppProvider";

export function useRedirect() {
  const { isStandaloneApp } = useApp();

  return (path: string, isInNewTab?: boolean) => {
    const url = isStandaloneApp
      ? `${environment.mainAppUrl}/#/${path}`
      : `/#/${path}`;

    if (isInNewTab) {
      window.open(url, "_blank")?.focus();
    } else {
      window.location.href = url;
    }
  };
}
